enum Car {
  Bill = 'car.bill',
  Document = 'car.document',
  IsNew = 'car.isNew',
  Plate = 'car.plate',
  Year = 'car.year'
}

enum Checkout {
  InsurableCar = 'insurableCar'
}

enum Device {
  Apartment = 'device.address.apartment',
  County = 'device.address.county',
  Number = 'device.address.number',
  Region = 'device.address.region',
  Street = 'device.address.street',
  UseResidenceAddress = 'device.useResidenceAddress'
}

enum Inspection {
  Apartment = 'inspection.address.apartment',
  Branch = 'inspection.branch',
  County = 'inspection.address.county',
  Number = 'inspection.address.number',
  Region = 'inspection.address.region',
  Street = 'inspection.address.street',
  Type = 'inspection.inspectionType',
  UseResidenceAddress = 'inspection.useResidenceAddress'
}

enum Owner {
  Birthdate = 'owner.birthdate',
  CivilStatus = 'owner.civilStatus',
  Email = 'owner.email',
  Gender = 'owner.gender',
  LastName = 'owner.lastName',
  Name = 'owner.name',
  NationalId = 'owner.nationalId',
  BusinessName = 'owner.businessName',
  Phone = 'owner.phone',
  SecondLastName = 'owner.secondLastName',
  Type = 'owner.type',
  CompanyName = 'owner.company.name',
  CompanyNationalId = 'owner.company.nationalId'
}

enum Payer {
  LastName = 'payer.lastName',
  Name = 'payer.name',
  NationalId = 'payer.nationalId',
  SecondLastName = 'payer.secondLastName',
  Type = 'payer.type'
}

enum Payment {
  AccountNumber = 'payment.accountNumber',
  Bank = 'payment.bank',
  CardMonth = 'payment.creditCard.expirationMonth',
  CardNumber = 'payment.creditCard.number',
  CardYear = 'payment.creditCard.expirationYear',
  Coupon = 'payment.coupon',
  CouponCode = 'payment.coupon.code',
  Method = 'payment.method',
  Voucher = 'payment.voucher'
}

enum Policy {
  AcceptTerms = 'policy.acceptTerms',
  ProposalUrl = 'policy.proposalUrl'
}

enum Residence {
  Apartment = 'residenceAddress.apartment',
  County = 'residenceAddress.county',
  Number = 'residenceAddress.number',
  Region = 'residenceAddress.region',
  Street = 'residenceAddress.street'
}

enum PreInspection {
  Status = 'preInspection.status',
  PreInspection = 'preInspection.preInspection'
}

enum NoFields {
  AboutDevice = 'AboutDevice',
  AboutEngineNumberDocument = 'AboutEngineNumberDocument',
  AboutInspectionBySelf = 'AboutInspectionBySelf',
  BankWarning = 'BankWarning',
  CarSummary = 'CarSummary',
  ContractRequirements = 'ContractRequirements',
  DeviceWarning = 'DeviceWarning',
  FirstPatPaymentInfo = 'FirstPatPaymentInfo',
  GoToBankField = 'GoToBankField',
  HowToPayOneClick = 'HowToPayOneClick',
  InspectionAccidentRateWarning = 'InspectionAccidentRateWarning',
  InspectionAddressSummary = 'InspectionAddressSummary',
  InspectionSubtitle = 'InspectionSubtitle',
  InspectionWarning = 'InspectionWarning',
  IsNewInformation = 'IsNewInformation',
  ManualPAC = 'ManualPAC',
  PersonSummary = 'PersonSummary',
  CompanySummary = 'CompanySummary',
  PolicyDownloader = 'PolicyDownloader',
  ProtectedDataWarning = 'ProtectedDataWarning',
  RegisterPAC = 'RegisterPAC',
  ResidenceAddressSummary = 'ResidenceAddressSummary',
  ResidenceSubtitle = 'ResidenceSubtitle'
}

export {
  Car,
  Checkout,
  Device,
  Inspection,
  Owner,
  Payer,
  Payment,
  Policy,
  Residence,
  PreInspection,
  NoFields
};
